import React, { useState, useRef, useEffect } from 'react';
import './QueuesManagmentPage.css';
// import PersonIcon from '@mui/icons-material/Person';

import RoomsTable from './RoomsTable';
import Sidebar from '../sidebar/sidebar';
import DeletePatientModal from './modals/DeletePatient';
import EmergencyDoctorAlertModal from './modals/EmergencyDoctorAlert';
import AddPatientModal from './modals/AddNewPatient';
import AddRoomModal from './modals/AddNewRoom';
import DeleteRoomModal from './modals/DeleteRoom';
import { deleteRoom } from '../../clientServices/RoomService';
import useReceptionSocket from '../../clientServices/ReceptionSocket';
import { useLocation, useNavigate } from 'react-router-dom';
// import Role from '../Role/role';
import EditRoomModal from './modals/EditRoom';
import InitQueuesModal from './modals/InitQueuesModal'; // Import the new modal
import CachedIcon from '@mui/icons-material/Cached';
import PatientAndQueueDetails from './patientAndQueueDetails'
import AddIcon from '@mui/icons-material/Add';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const QueueManagmentPage = () => {
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [selectedRoom, setSelectedRoom] = useState(null);
    const [selectedRoomInTable, setSelectedRoomInTable] = useState(null);
    const [patients, setPatients] = useState([]);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isEmergencyModalOpen, setIsEmergencyModalOpen] = useState(false);
    const [isAddPatientModalOpen, setIsAddPatientModalOpen] = useState(false);
    const [isAddRoomModalOpen, setIsAddRoomModalOpen] = useState(false);
    const [isRoomDeleteModalOpen, setIsRoomDeleteModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('rooms'); // Track the selected tab
    const [isEditRoomModalOpen, setIsEditRoomModalOpen] = useState(false);
    const [isInitQueuesModalOpen, setIsInitQueuesModalOpen] = useState(false); // Modal state



    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
        localStorage.setItem('activeTab', tabName); // Save the selected tab to localStorage
    };


    const { emergencyAlertToDoctor, endOfTreatment, insertPatient, updateRoomList, initAllSystem } = useReceptionSocket(setSelectedPatient, patients, setPatients);

    const location = useLocation();
    const role = location.state;

    const childRef = useRef();

    const navigate = useNavigate();


    const goToMonitoManagerrPage = () => {
        navigate('/monitorManager');
    };

    const initSystem = async () => {
        initAllSystem();
    };

    const handleSelectRoomInTable = (room) => {
        setSelectedRoomInTable(room);
    };

    const handleCloseDeleteModal = () => {
        setIsDeleteModalOpen(false);
    };

    const handleCloseRoomDeleteModal = () => {
        setIsRoomDeleteModalOpen(false);
    };

    const handleCloseEmergencyModal = () => {
        setIsEmergencyModalOpen(false);
    };

    const handleConfirmDeleteModal = async () => {
        try {
            endOfTreatment(selectedPatient.ID);
            alert('הטיפול הסתיים בהצלחה');
            setSelectedPatient(null);
            handleCloseDeleteModal();
        } catch (error) {
            console.error('Error deleting patient:', error);
            alert('Failed to delete patient.');
        }
    };

    const handleConfirmRoomDeleteModal = async () => {
        try {
            console.log(selectedRoomInTable.ID)
            await deleteRoom(selectedRoomInTable.ID);
            alert('החדר נמחק בהצלחה');
            setSelectedRoomInTable(null);
            handleCloseRoomDeleteModal();
            updateRoomList();
            window.location.reload()
        } catch (error) {
            // בדיקת שגיאות שמגיעות מהשרת
            if (error.response && error.response.status === 400) {
                // הצגת הודעת השגיאה מהשרת
                const message = error.response.data.message;
                alert(message);
            } else {
                // טיפול בשגיאה כללית
                alert('יש מטופלים בחדר כרגע, אין אפשרות למחוק');
            }
        }
    };

    const handleConfirmEmergencyModal = () => {
        emergencyAlertToDoctor(selectedPatient.UniqueNumber, selectedRoom.Name);
        alert('קריאת חירום נשלחה לרופא');
        handleCloseEmergencyModal();
    };

    const handleOpenAddPatientModal = () => {
        setIsAddPatientModalOpen(true);
    };

    const handleCloseAddPatientModal = () => {
        setIsAddPatientModalOpen(false);
    };

    const handleOpenAddRoomModal = () => {
        setIsAddRoomModalOpen(true);
    };

    const handleCloseAddRoomModal = () => {
        setIsAddRoomModalOpen(false);
    };

    const handleOpenEditRoomModal = () => {
        if (selectedRoomInTable) {
            setIsEditRoomModalOpen(true);

        }
        else {
            console.log(selectedRoomInTable)
            alert("בחר חדר לעריכה")

        }
    };

    const handleCloseEditRoomModal = () => {
        setIsEditRoomModalOpen(false);
    };

    const handleOpenInitQueuesModal = () => {
        setIsInitQueuesModalOpen(true);
    };

    // Handler to close the modal
    const handleCloseInitQueuesModal = () => {
        setIsInitQueuesModalOpen(false);
    };

    useEffect(() => {
        const savedTab = localStorage.getItem('activeTab');
        if (savedTab) {
            setActiveTab(savedTab);
        }
    }, []);



    return (
        <>
            <div className='queueManagmentContainer'>
                <Sidebar role={role} />
                <div className='patientsDetailsTableContainer'>
                    <div className="tabs">
                        <div
                            className={`managementTitle ${activeTab === 'patients' ? 'active' : ''}`}
                            onClick={() => handleTabClick('patients')}

                        >
                            סטטוס תורים
                        </div>
                        <div
                            className={`managementTitle ${activeTab === 'rooms' ? 'active' : ''}`}
                            onClick={() => handleTabClick('rooms')}

                        >
                            חדרים
                        </div>
                        <div
                            className={`managementTitle ${activeTab === 'generalQueueManagement' ? 'active' : ''}`}
                            onClick={() => handleTabClick('generalQueueManagement')}
                        >
                            ניהול כללי
                        </div>
                    </div>
                    {activeTab === 'patients' && (
                        <div className='card'>
                            <div className='patientsDetailsTableCont'>

                                <div className='tableAndOperationCont'>
                                    <PatientAndQueueDetails
                                        setSelectedPatient={setSelectedPatient}
                                        patients={patients}
                                        setPatients={setPatients}
                                    />

                                    <div className='moreOperationCont'>
                                        <div className='actionOfPatientContainer'>
                                            <button className='addPatientManual anotherButtons' onClick={handleOpenAddPatientModal}>
                                                <AddIcon className='svgIcon' />
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {activeTab === 'rooms' && (
                        <div className='card'>
                            <RoomsTable ref={childRef} onSelectRoomInTable={handleSelectRoomInTable} updateRoomList={updateRoomList} />
                            <div className='moreOperationCont'>
                                <div className='actionOfPatientContainer'>
                                    <button className='moreOperation' onClick={() => setIsRoomDeleteModalOpen(true)}>מחיקת חדר</button>
                                    <button className='moreOperation' onClick={handleOpenAddRoomModal}>הוספת חדר</button>
                                    <button className='moreOperation' onClick={handleOpenEditRoomModal}>ערוך חדר</button>
                                    <button className='moreOperation' onClick={() => childRef.current.handleToggleStatus()}>שנה סטטוס פעילות</button>
                                </div>
                            </div>
                        </div>
                    )}


                    {activeTab === 'generalQueueManagement' && (
                        <div className='card'>
                            <button className='endDayBtn' onClick={handleOpenInitQueuesModal}>
                                <div >איתחול נתונים</div>
                                <CachedIcon style={{ marginRight: "5px" }} />

                            </button>
                            <button className='endDayBtn' onClick={goToMonitoManagerrPage}>
                                <div >ניהול תצוגת מוניטור</div>
                                <AutoAwesomeIcon style={{ marginRight: "5px" }} />

                            </button>
                        </div>
                    )}

                </div>

                {/* <Role /> */}

            </div>

            <DeletePatientModal
                open={isDeleteModalOpen}
                handleClose={handleCloseDeleteModal}
                handleConfirm={handleConfirmDeleteModal}
                patientName={selectedPatient}
            />
            <DeleteRoomModal
                open={isRoomDeleteModalOpen}
                handleClose={handleCloseRoomDeleteModal}
                handleConfirm={handleConfirmRoomDeleteModal}
                updateRoomList={updateRoomList}
                roomName={selectedRoomInTable ? `${selectedRoomInTable.Name}` : ''}
            />

            <EmergencyDoctorAlertModal
                open={isEmergencyModalOpen}
                handleClose={handleCloseEmergencyModal}
                handleConfirm={handleConfirmEmergencyModal}
                patientName={selectedPatient}
                roomName={selectedRoomInTable ? selectedRoomInTable.Name : ''}
            />

            <AddPatientModal
                open={isAddPatientModalOpen}
                handleClose={handleCloseAddPatientModal}
                insert={insertPatient}
            />

            <AddRoomModal
                open={isAddRoomModalOpen}
                handleClose={handleCloseAddRoomModal}
                updateRoomList={updateRoomList}
            />

            <EditRoomModal
                open={isEditRoomModalOpen}
                handleClose={handleCloseEditRoomModal}
                room={selectedRoomInTable}
                updateRoomList={updateRoomList}
            />

            <InitQueuesModal
                open={isInitQueuesModalOpen}
                handleClose={handleCloseInitQueuesModal}
                onConfirm={handleCloseInitQueuesModal}
                initSystem={initSystem}
            />
        </>
    );
};

export default QueueManagmentPage;



